import {
  Select,
  STATUSPAGE,
  PageWrapper,
  FormFeedBack,
  SUBMIT_BUTTON,
  NoDataComponent,
  TableVirtualized,
  CustomDateRangePicker,
  convertEventSelectToTarget,
  parseLocalDateFromYYYYMMDD,
  SimpleTableLoadingSkeleton,
  convertDateToYYYYMMDDFormat,
} from '@repo/ui';
import noData from 'presentation/app/assets/images/no-task.png';
import { useNumberStudentsPerProfessionalInField } from 'presentation/app/modules/Reports/hooks/useNumberStudentsPerProfessionalInField';
import { Card, Col, Label, Row, Spinner } from 'reactstrap';

import { makeNumberStudentsPerProfessionalInFieldColumns } from '../../../common/columns/professionals/number-students-per-professional-in-field-columns';
import { ReportsGeneralFilters } from '../../../components/reports-general-filters';
import './styles.scss';

export const PageNumberStudentsPerProfessionalInTheField = () => {
  const {
    validation,
    tableLoading,
    buttonsLoading,
    hasFetchedData,
    periodTypeOptions,
    selectedSubmitBtnRef,
    numberStudentsPerProfessionalInFieldData,
  } = useNumberStudentsPerProfessionalInField();

  const dates = numberStudentsPerProfessionalInFieldData?.dates || [];

  const formattedData =
    numberStudentsPerProfessionalInFieldData?.data.map((row) => ({
      id: row.professionalHashId,
      professionalName: row.professionalName,
      total: row.total,
      ...dates.reduce(
        (acc, date) => ({
          ...acc,
          [date]: row.studentsByDate?.[date] || 0,
        }),
        {},
      ),
    })) || [];

  return (
    <PageWrapper title="Profissionais">
      <Col className="mb-3 border-0 d-flex align-items-end justify-content-between">
        <h4>Relatório de Quantidade de Estudantes por Profissional em Campo</h4>
      </Col>

      <Card>
        <ReportsGeneralFilters
          validation={validation}
          isGroupMulti={false}
          inputsChildren={
            <>
              <Col md={4} className="mb-3">
                <Label htmlFor="periodType" className="form-label">
                  Tipo de Período:
                </Label>
                <Select
                  // isClearable
                  id="periodType"
                  name="periodType"
                  value={validation.values.periodType}
                  onChange={(e) =>
                    validation.handleChange(
                      convertEventSelectToTarget('periodType', e),
                    )
                  }
                  invalid={
                    !!(
                      validation.touched?.periodType &&
                      validation.errors?.periodType
                    )
                  }
                  onBlur={validation.handleBlur}
                  options={periodTypeOptions}
                />
                <FormFeedBack
                  error={validation.errors?.periodType?.toString()}
                  isInvalid={
                    !!(
                      validation.touched?.periodType &&
                      validation.errors?.periodType
                    )
                  }
                />
              </Col>
              <Col sm={12} md={6} lg={4} className="mb-3">
                <Row>
                  <Label htmlFor="initial-date" className="form-label">
                    Período:
                  </Label>
                  <CustomDateRangePicker
                    initialStartDate={parseLocalDateFromYYYYMMDD(
                      validation.values.starts,
                    )}
                    initialEndDate={parseLocalDateFromYYYYMMDD(
                      validation.values.ends,
                    )}
                    placement="auto"
                    onDateChange={(start, ends) => {
                      validation.setFieldValue(
                        'starts',
                        convertDateToYYYYMMDDFormat(start),
                      );
                      validation.setFieldValue(
                        'ends',
                        convertDateToYYYYMMDDFormat(ends),
                      );
                    }}
                  />
                </Row>
              </Col>
            </>
          }
          buttonsChildren={
            <div className="w-100 d-flex justify-content-end gap-2">
              <button
                id="search-button-json"
                type="submit"
                onClick={() => {
                  selectedSubmitBtnRef.current = SUBMIT_BUTTON.JSON;
                }}
                className="btn btn-primary waves-effect waves-light"
                disabled={
                  buttonsLoading === STATUSPAGE.LOADING &&
                  selectedSubmitBtnRef.current === SUBMIT_BUTTON.JSON
                }
              >
                {selectedSubmitBtnRef.current === SUBMIT_BUTTON.JSON &&
                buttonsLoading === STATUSPAGE.LOADING ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Visualizar
                    <i className="ri-computer-line mx-2"></i>
                  </>
                )}
              </button>
              <button
                id="export-excel"
                type="submit"
                onClick={() => {
                  selectedSubmitBtnRef.current = SUBMIT_BUTTON.EXCEL;
                }}
                className="btn btn-light waves-effect waves-light"
                disabled={
                  buttonsLoading === STATUSPAGE.LOADING &&
                  selectedSubmitBtnRef.current === SUBMIT_BUTTON.EXCEL
                }
              >
                {selectedSubmitBtnRef.current === SUBMIT_BUTTON.EXCEL &&
                buttonsLoading === STATUSPAGE.LOADING ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Exportar para Excel
                    <i className="ri-file-excel-2-line mx-2"></i>
                  </>
                )}
              </button>
            </div>
          }
        />

        {formattedData.length === 0 &&
          hasFetchedData &&
          tableLoading === STATUSPAGE.DONE && (
            <div className="p-4">
              <NoDataComponent src={noData} />
            </div>
          )}

        {tableLoading === STATUSPAGE.LOADING && <SimpleTableLoadingSkeleton />}

        {tableLoading === STATUSPAGE.DONE && formattedData.length > 0 && (
          <div className="students-per-professional-field-report-table">
            <TableVirtualized
              columns={makeNumberStudentsPerProfessionalInFieldColumns(dates)}
              data={formattedData}
              fixed
            />
          </div>
        )}
      </Card>
    </PageWrapper>
  );
};
